<!-- <app-sidebar
  [showSidebarAndHeader]="showSidebarAndHeader"
  class="hide-scrollbar"
></app-sidebar> -->
<div class="flex flex-col w-full h-screen">
  <div *ngIf="showHeader" class="w-full">
    <app-header class="top-0"></app-header>
  </div>
  <div class="w-full hide-scrollbar">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
</div>
